import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button } from '@driftt/tide-core-legacy'
import MarketplaceModal from '@driftt/playbook-marketplace-components'
import { getGates } from 'app/modules/gates/selectors'
import { currentUser as getCurrentUser, botUser as getBotUser } from 'app/modules/user/selectors'
import { getEmbedConfig } from 'app/modules/embed/selectors'
import * as OrgSelectors from 'app/modules/org/selectors'
import { track } from 'app/modules/tracking/actions'
import * as OrgActions from 'app/modules/org/actions'
import { bindActionCreators } from 'redux'

const mapStateToProps = state => ({
  gates: getGates(state),
  currentUser: getCurrentUser(state),
  botUser: getBotUser(state),
  embedConfig: getEmbedConfig(state),
  hasLimitedContactsMktEmail: OrgSelectors.hasLimitedContactsMktEmail(state),
})

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      track,
      hasLimitedContactsMktEmail: OrgActions.hasLimitedContactsMktEmail,
    }, dispatch)
  }
}

class ModalCreatePlaybookButton extends Component {
  constructor(props) {
    super(props)
    this.state = { marketplaceModalOpen: !!props.isOpen ? props.isOpen : false }
    this.props.actions.hasLimitedContactsMktEmail()
  }

  toggleMarketplaceModal = (isOpen) => {
    this.setState({ marketplaceModalOpen: isOpen })
    if (isOpen) {
      window.drift && window.drift.hide()
      this.props.actions.track('Marketplace Modal - Opened', {
        buttonText: 'Create new playbook'
      })
    } else {
      window.drift && window.drift.show()
    }
  }

  render() {
    const { marketplaceModalOpen } = this.state
    const { gates, currentUser, botUser, embedConfig, buttonText, hasLimitedContactsMktEmail } = this.props
    return (
      <div>
        <Button onClick={() => this.toggleMarketplaceModal(true)}>{buttonText}</Button>
        <MarketplaceModal openMarketplace={marketplaceModalOpen} onClose={() => this.toggleMarketplaceModal(false)} gates={gates} user={currentUser} botUser={botUser} embedConfig={embedConfig} hasLimitedContacts={hasLimitedContactsMktEmail} />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreatePlaybookButton)


// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/MarketplaceModalButton/index.js